var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.iconImg.component)?_c(_vm.iconImg.component,_vm._b({tag:"component",staticClass:"file-format-icon",style:({ width: _vm.width + 'px', height: _vm.height + 'px' })},'component',_vm.iconImg.props,false)):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }